import { Service, inject } from '@angular/core';
import { OrgGroupShort } from '@degreed/lxp/org/models';
import { NgxHttpClient } from '@degreed/lxp/services';
import {
  Observable,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  of,
  switchMap,
} from 'rxjs';
import { TypeaheadSearchFunction } from '../../models/typeahead-search.model';

export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 2;

@Service()
export class OrgGroupSearchService {
  private http = inject(NgxHttpClient);

  /**
   * Load groups from the server based on the search term
   *
   * @param searchTerm
   * @returns
   */
  public loadGroups: TypeaheadSearchFunction<string, OrgGroupShort> = (
    searchTerm: Observable<string>
  ): Observable<readonly OrgGroupShort[]> =>
    searchTerm.pipe(
      map((term) => term.trim()),
      debounceTime(SEARCH_DEBOUNCE_MS),
      distinctUntilChanged(),
      filter((term) => term.length >= MIN_SEARCH_LENGTH),
      switchMap((term: string) =>
        this.getGroupSuggestions(term).pipe(
          catchError(() => of([] as OrgGroupShort[]))
        )
      )
    );

  /**
   * Get a list of possible Admin Groups from a search term
   * @param searchTerm
   * @returns
   */
  private getGroupSuggestions(searchTerm: string): Observable<OrgGroupShort[]> {
    return this.http.get<OrgGroupShort[]>('/search/findadmingroups', {
      params: {
        term: searchTerm,
      },
    });
  }
}
